import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-leilao02',
  templateUrl: './leilao02.component.html',
  styleUrls: ['./leilao02.component.scss']
})
export class Leilao02Component implements OnInit  {
 
  constructor(private route: ActivatedRoute, private router: Router) {}
 
  ngOnInit(){
  }

  voltar(){
    this.router.navigate([''], { relativeTo: this.route });
  }
}

